"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var webAApi_1 = require("../../../../api/webAApi");
var ReportWithdrawsListCtl = /** @class */ (function (_super) {
    __extends(ReportWithdrawsListCtl, _super);
    function ReportWithdrawsListCtl(errDialog, controller) {
        var _this = _super.call(this, true) || this;
        _this.dk_gws_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_title; });
        _this.dk_prv_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.prv_title; });
        _this.dk_success_withdraws_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.success_withdraws_count; });
        _this.dk_total_withdraws_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_withdraws_count; });
        _this.dk_success_withdraws_rate = UIUtils_1.UIUtils.IProp2Str(function (o) { o.success_withdraws_rate; });
        _this.dk_success_withdraws_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.success_withdraws_amount; });
        _this.dk_total_withdraws_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.total_withdraws_amount; });
        _this.dk_avg_withdraws_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.avg_withdraws_amount; });
        _this._errDialog = errDialog;
        _this._controller = controller;
        return _this;
    }
    ReportWithdrawsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total_count: 0,
            app_currency_id: 0,
            app_currency_iso: "",
            app_currency_symbol: "",
            tota_success_withdraws_count: 0,
            tota_total_withdraws_count: 0,
            tota_success_withdraws_rate: 0,
            tota_success_withdraws_amount: 0,
            tota_total_withdraws_amount: 0,
            tota_avg_withdraws_amount: 0,
            data_total: []
        };
    };
    ReportWithdrawsListCtl.prototype.LoadData = function (dtRange, onDone) {
        var _this = this;
        webAApi_1.ListWithdrawalsStatsReportByDateRangeGet.exec({
            from_year: dtRange.from_year,
            from_month: dtRange.from_month,
            from_day: dtRange.from_day,
            to_year: dtRange.to_year,
            to_month: dtRange.to_month,
            to_day: dtRange.to_day,
            brands_id_list: dtRange.brands_id_list,
            all_brands: dtRange.all_brands,
            limit: dtRange.limit,
            offset: dtRange.offset,
            app_currency_id: dtRange.app_currency_id
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.data_total = [];
            _this.DATA.total_count = resp.total_count;
            _this.DATA.app_currency_id = resp.app_currency_id;
            _this.DATA.app_currency_iso = resp.app_currency_iso;
            _this.DATA.app_currency_symbol = resp.app_currency_symbol;
            _this.DATA.tota_success_withdraws_count = resp.tota_success_withdraws_count;
            _this.DATA.tota_total_withdraws_count = resp.tota_total_withdraws_count;
            _this.DATA.tota_success_withdraws_rate = resp.tota_success_withdraws_rate;
            _this.DATA.tota_success_withdraws_amount = resp.tota_success_withdraws_amount;
            _this.DATA.tota_total_withdraws_amount = resp.tota_total_withdraws_amount;
            _this.DATA.tota_avg_withdraws_amount = resp.tota_avg_withdraws_amount;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    gws_title: resp.list[i].gws_title,
                    prv_title: resp.list[i].prv_title,
                    success_withdraws_count: resp.list[i].success_withdraws_count,
                    total_withdraws_count: resp.list[i].total_withdraws_count,
                    success_withdraws_rate: resp.list[i].success_withdraws_rate,
                    success_withdraws_amount: resp.list[i].success_withdraws_amount,
                    total_withdraws_amount: resp.list[i].total_withdraws_amount,
                    avg_withdraws_amount: resp.list[i].avg_withdraws_amount,
                    total: false
                });
            }
            _this.DATA.data_total.push({
                gws_title: "ИТОГО",
                prv_title: "",
                success_withdraws_count: _this.DATA.tota_success_withdraws_count,
                total_withdraws_count: _this.DATA.tota_total_withdraws_count,
                success_withdraws_rate: _this.DATA.tota_success_withdraws_rate,
                success_withdraws_amount: _this.DATA.tota_success_withdraws_amount,
                total_withdraws_amount: _this.DATA.tota_total_withdraws_amount,
                avg_withdraws_amount: _this.DATA.tota_avg_withdraws_amount,
                total: true
            });
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ReportWithdrawsListCtl.prototype.doExportObjectArray = function (dtRange, onDone) {
        var _this = this;
        var _data = [];
        this.LoadData(dtRange, function () {
            for (var i = 0; i < _this.DATA.data.length; i++) {
                _data.push({
                    gws_title: _this.DATA.data[i].gws_title,
                    prv_title: _this.DATA.data[i].prv_title,
                    success_withdraws_count: _this.DATA.data[i].success_withdraws_count,
                    total_withdraws_count: _this.DATA.data[i].total_withdraws_count,
                    success_withdraws_rate: _this.DATA.data[i].success_withdraws_rate,
                    success_withdraws_amount: _this.DATA.data[i].success_withdraws_amount,
                    total_withdraws_amount: _this.DATA.data[i].total_withdraws_amount,
                    avg_withdraws_amount: _this.DATA.data[i].avg_withdraws_amount,
                });
            }
            _data.push({
                gws_title: "ИТОГО",
                prv_title: "",
                success_withdraws_count: _this.DATA.tota_success_withdraws_count,
                total_withdraws_count: _this.DATA.tota_total_withdraws_count,
                success_withdraws_rate: _this.DATA.tota_success_withdraws_rate,
                success_withdraws_amount: _this.DATA.tota_success_withdraws_amount,
                total_withdraws_amount: _this.DATA.tota_total_withdraws_amount,
                avg_withdraws_amount: _this.DATA.tota_avg_withdraws_amount,
            });
            if (onDone) {
                onDone(_data);
            }
        });
    };
    return ReportWithdrawsListCtl;
}(BaseController_1.BaseController));
exports.ReportWithdrawsListCtl = ReportWithdrawsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/rep_withdrawals/ctl/RepWithdrawalsCtl.ts
// module id = 1050
// module chunks = 0